import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { IOptionsResponse } from '../../../common/common.types'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { OptionsService } from '../services/options.service'
import { setCriticalCareActionOptions } from '../store/options.actions'

export function* getCriticalCareActionOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const criticalCareActionOptionsResponse: IOptionsResponse = yield call([
      optionsService,
      optionsService.getCriticalCareActionOptions,
    ])
    const { entity } = criticalCareActionOptionsResponse
    if (entity) yield put(setCriticalCareActionOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getCriticalCareActionOptions() error: ${e}`))
  }
}

export function* getCriticalCareActionOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getCriticalCareActionOptions)
}
